/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rights_Tools_Posture_Allow_AllInputs */



/**
* | output |
* | --- |
* | "Offer all tools" |
*
* @param {Rights_Tools_Posture_Allow_AllInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const rights_tools_posture_allow_all = /** @type {((inputs?: Rights_Tools_Posture_Allow_AllInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rights_Tools_Posture_Allow_AllInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Alle Tools anbieten")
	return /** @type {LocalizedString} */ ("Offer all tools")
});